import React from 'react'
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import {MapWithMakerProps} from '../../types/props/MapWithMakerProps';
const MapWithAMarker = withGoogleMap(({ center, markerPosition, handleMapClick }: MapWithMakerProps) => {
    return (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={center}
        defaultOptions={{
          gestureHandling: 'greedy',
          disableDefaultUI: false,
          zoom: 12,
          minZoom: 5,
          maxZoom: 18,
          streetViewControl: false,
          rotateControl: false,
          panControl: false,
          mapTypeControl: false,
        }}
        onClick={handleMapClick}
      >
        {
          markerPosition && <Marker position={markerPosition} />
        }
  
      </GoogleMap>
    )
  }
  );
export default MapWithAMarker;
